import { Column } from 'react-table'
import { columnGenerators } from '../../../../../../_metronic/helpers'

export const header = (isSupplyChainManager = false) => [
  {
    label: 'S.N',
    value: 'S.N',
  },
  {
    label: 'Date',
    value: 'actualCollectionDate',
  },
  // {
  //   label: 'Type',
  //   value: 'wasteSource',
  // },
  {
    label: 'Batch id',
    value: 'materialInwardBatchId',
  },
  {
    label: 'Material Hub',
    value: 'pickupPointName',
  },
  // {
  //   label: isSupplyChainManager ? 'Supply chain' : 'Franchisee',
  //   value: 'franchiseName',
  // },
  {
    label: 'Category',
    value: 'categoryNameCollectOrder',
  },
  // {
  //   label: 'Item',
  //   value: 'remark',
  // },
  {
    label: 'Quantity (kg)',
    value: 'quantityDeposit_remark',
  },
  // {
  //   label: 'Price',
  //   // value: 'price',
  //   value: 'totalAmountI',
  // },
  {
    label: 'Plastic Keeper',
    value: 'B2B1',
  },
  {
    label: 'Log info',
    value: 'loginfo',
  },
  {
    label: 'Status',
    value: 'status',
  },
  // {
  //   label: 'Rating',
  //   value: 'mirating',
  // },
  // {
  //   label: 'Contact',
  //   value: 'customerInfo[mobile]',
  // },
  {
    action: [''],
  },
]

const roleColumns = (isSupplyChainManager = false) => {
  return columnGenerators(header(isSupplyChainManager))
}
export { roleColumns }
